import { EditableText, defineBlock } from "eddev/blocks"
import { useSubtheme } from "@hooks/useSubtheme"
import { Marquee } from "@components/atoms/Marquee"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { twMerge } from "tailwind-merge"
import DiamondLatticeBackground from "@components/atoms/DiamondLattice"
import { useRef, useState } from "react"

export const meta: BlockMeta = {
  title: "Road Safety Research Header",
  category: "common",
  icon: "car",
  tags: ["root"],
  editMode: "preview",
  conditions: {
    postTypes: ["page", "post"],
    multiple: false,
  },
}

export default defineBlock("rsrh/rsrh-header", (props) => {
  useSubtheme("yellowHeader")

  const videoRef = useRef<HTMLVideoElement>(null)
  const [isPlaying, setIsPlaying] = useState(false)

  return (
    <div className="w-full bg-yellow flex flex-col gap-6 pb-8 relative z-0">
      <div className="grid-auto py-8 relative z-10">
        <div className="col-span-12 md:col-span-10 lg:col-span-8 md:col-start-2 lg:col-start-3 flex flex-col items-center justify-center gap-4 !text-center">
          <EditableText as="h1" className="!type-title-xl" store="title" placeholder="Enter title" />
          <EditableText as="span" className="type-title-s" store="subheader" placeholder="Enter subheader" />
        </div>
      </div>

      {props.sponsors && props.sponsors.length > 0 && (
        <div className="flex flex-col gap-4 items-center justify-center relative z-10">
          <span className="type-label-caps">Research partners</span>
          <Marquee>
            {props.sponsors.map((logo, i) => (
              <div
                key={i}
                className={twMerge(
                  "w-[120px] h-[120px] flex box-content items-center justify-center px-6",
                  "[&>div]:w-full [&>div]:bg-transparent",
                )}
              >
                <ResponsiveImage {...logo?.logo} />
              </div>
            ))}
          </Marquee>
          <EditableText
            as="span"
            className="type-label-caps px-6 w-full text-center"
            store="marquee"
            placeholder="Enter text..."
          />
        </div>
      )}

      {props.video?.mediaItemUrl && (
        <div className="flex flex-col gap-4 items-center justify-center relative z-10">
          <div className="grid-auto">
            <div className="col-span-12">
              <video
                ref={videoRef}
                width="100%"
                playsInline
                controls={isPlaying}
                onPlay={() => setIsPlaying(true)}
                onClick={() => !isPlaying && videoRef.current?.play()}
                className="w-full h-auto overflow-hidden rounded-lg [&[poster]]:object-cover"
                poster={props.videoPoster?.mediaItemUrl ?? undefined}
              >
                <source src={props.video.mediaItemUrl} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      )}

      <div className="absolute z-0 top-[10%] left-0 w-full h-[300px]">
        <DiamondLatticeBackground />
      </div>
    </div>
  )
})
